import {
	createDonePlatformState,
	createIdlePlatformState,
	getPlatformResultFromShotlist
} from '@/features/FormUploader/helpers/platformHeaderState'
import { IShotlist } from '@/types/shotlist.interface'
import {
	IFetchUploadForm,
	ISelectedPlatform
} from '@/types/uploadForm.interface'

export const prefetchFormHeaderState = ({
	formData,
	shotlist
}: {
	formData: IFetchUploadForm
	shotlist: IShotlist
}): {
	list: ISelectedPlatform[]
} => {
	const platforms = (formData.platforms_order || []).filter(
		plat => formData.platforms?.[plat] !== null
	)

	const list: ISelectedPlatform[] = platforms.map((plat, index) => {
		const autoFilling = index >= 1
		const result = getPlatformResultFromShotlist({
			value: plat,
			shotlist
		})

		if (result) {
			return createDonePlatformState({
				value: plat,
				result,
				autoFilling
			})
		}

		return createIdlePlatformState({
			value: plat,
			autoFilling
		})
	})

	return {
		list
	}
}
